export default "__VITE_ASSET__C7F9uq1C__"